import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Table, Spin, Button, Modal, Tooltip } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import AlertWarningCreationForm from "../../Forms/AlertWarningCreationForm/AlertWarningCreationForm";

const AlertWarningTable = ({
  history,
  loading,
  data,
  callReFetch,
  counterData,
  dispatch,
  handleDelete,
}) => {
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [selectedAlertWarning, setSelectedAlertWarning] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleOpenEditModal = async (id) => {
    const alertToEdit = data.find((item) => item._id === id);
    if (alertToEdit) {
      setSelectedAlertWarning(alertToEdit);
      setIsEditModalVisible(true);
    }
  };

  const handleCloseEditModal = () => {
    setIsEditModalVisible(false);
    setSelectedAlertWarning(null);
  };

  const renderActionButton = (id) => (
    <>
      {isMobileView ? (
        <>
          <Tooltip title="Edit">
            <Button
              icon={<EditOutlined />}
              onClick={() => handleOpenEditModal(id)}
              size="small"
              shape="circle"
              style={{ marginRight: 8 }}
            />
          </Tooltip>
          <Tooltip title="Delete">
            <Button
              icon={<DeleteOutlined />}
              onClick={() => handleDelete(id)}
              size="small"
              shape="circle"
              danger
            />
          </Tooltip>
        </>
      ) : (
        <>
          <Button
            onClick={() => handleOpenEditModal(id)}
            style={{ marginRight: 8 }}
          >
            Edit
          </Button>
          <Button onClick={() => handleDelete(id)} danger>
            Delete
          </Button>
        </>
      )}
    </>
  );

  const handleTableOnChange = (pagination, filteredInfo, sorter) => {
    dispatch({ type: "sorter", payload: sorter });
    dispatch({ type: "filteredInfo", payload: filteredInfo });
    callReFetch();
  };

  const columns = [
    {
      title: "Counter Code",
      dataIndex: "counterCode",
      key: "counterCode",
      sorter: true,
    },

    {
      title: "SKU",
      dataIndex: "sku",
      key: "sku",
      sorter: true,
    },
    {
      title: "Threshold",
      dataIndex: "threshold",
      key: "threshold",
      sorter: true,
    },
    {
      title: "Action",
      render: (item) => renderActionButton(item._id),
      width: 300,
    },
  ];

  return (
    <div style={{ width: "50vw" }}>
      <Spin spinning={loading}>
        {data && (
          <Table
            columns={columns}
            dataSource={data}
            rowKey="_id"
            onChange={handleTableOnChange}
          />
        )}
      </Spin>
      <Modal
        title="Edit Alert Warning"
        open={isEditModalVisible}
        footer={null}
        onCancel={handleCloseEditModal}
      >
        <AlertWarningCreationForm
          history={history}
          isEditMode
          callReFetch={callReFetch}
          counterData={counterData}
          data={selectedAlertWarning}
          onClose={handleCloseEditModal}
        />
      </Modal>
    </div>
  );
};

AlertWarningTable.propTypes = {
  history: PropTypes.object,
  loading: PropTypes.bool,
  data: PropTypes.array,
  callReFetch: PropTypes.func,
  counterData: PropTypes.array,
  dispatch: PropTypes.func,
  handleDelete: PropTypes.func,
};

export default AlertWarningTable;
